import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useSelector } from "react-redux";
import { togglePlaying } from "../../../store/playerMethods";

function VideoPlayer({ title, src, placeholder}) {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const onLoadedData = () => {
    setIsVideoLoaded(true);
  };

  const isPlaying = useSelector((state) => state.player.isPlaying);

  return (
    <>
      <div
        className={`ratio ratio-16x9 ${isVideoLoaded ? "" : "overflow-hidden"}`}
      >
        <div style={{ opacity: isVideoLoaded ? 0 : 1 }}>
          <img src={placeholder} alt="thumb" className="videoPlaceholder" />
        </div>
        <div id="videoPlayerHolder" style={{ opacity: isVideoLoaded ? 1 : 0 }}>
          <ReactPlayer
            url={src}
            playing={isPlaying}
            onStart={onLoadedData}
            controls={true}
            loop={true}
            muted={false}
            playsinline={true}
            width=""
            height=""
          />
        </div>
      </div>
    </>
  );
}

export default VideoPlayer;
